module.exports = __webpack_public_path__ + "img/ch-checkbook-res.ff740026.jpg";